<template>
	<transition name="fade" mode="out-in">
		<span class="svg" v-html="html" v-if="html && !loading" @click="$emit('click', $event)"></span>
		<span class="svg" v-if="loading">
			<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="svg-loader">
				<circle cx="50" cy="50" r="45" />
			</svg>
		</span>
	</transition>
</template>

<script>
	export default {
		props: ['icon'],
		data() {
			return {
				html: '',
				loading: false
			};
		},
		watch: {
			icon: {
				async handler() {
					this.html = '';
					if(!this.icon) {
						return;
					}
					if(this.$store.state.icons[this.icon]) {
						this.html = this.$store.state.icons[this.icon];
						return;
					}
					if(typeof(Storage) !== 'undefined') {
						const local = localStorage.getItem(this.icon);
						if(local) {
							this.$store.state.icons[this.icon] = local;
							this.html = this.$store.state.icons[this.icon];
							return;
						} 
					}
					this.loading = true;
					try {
						const data = await this.$get('/icons/' + this.icon + '.svg');
						this.html = data;
						this.$store.state.icons[this.icon] = data;
						if(typeof(Storage) !== 'undefined') {
							localStorage.setItem(this.icon, data);
						}
					} catch(e) {}
					this.loading = false;
				},
				immediate: true,
				deep: true
			}
		}
	}
</script>